import { render, staticRenderFns } from "./QRCard.vue?vue&type=template&id=1ac09967&lang=pug&"
import script from "./QRCard.vue?vue&type=script&lang=js&"
export * from "./QRCard.vue?vue&type=script&lang=js&"
import style0 from "./QRCard.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports